module.exports = "/static/assets/729f8aef73fe5151486419e055042a0c.png";